import styled from "styled-components";
import BasicTitle from "~/shared/components/BasicTitle";
import ParticipantTooltip from "~/shared/components/ParticipantTooltip";
import { PARTICIPANT_PATHS } from "~/team/constants/paths.constants";
import InlineLink from "../../shared/components/InlineLink";
import TableName from "../../shared/components/TableName";
import DataCell from "../../shared/components/table/DataCell";

const NameCellWrap = styled.div<{ hasHealthScore?: boolean }>`
  position: relative;

  ${(props) =>
    props.hasHealthScore &&
    `
    padding-left: 24px;
  `}
`;

interface TooltipWrapProps extends Pick<NameCellProps, "row" | "canShowTooltip"> {
  children: React.ReactElement;
}

const TooltipWrap = ({ row, canShowTooltip, children }: TooltipWrapProps) =>
  canShowTooltip ? <ParticipantTooltip user={row}>{children}</ParticipantTooltip> : children;

interface NameCellProps {
  row: any;
  canShowTooltip: boolean;
  showExtraLinks: boolean;
  forceNewTab?: boolean;
}

const NameCell = ({ row, canShowTooltip, showExtraLinks, forceNewTab = true }: NameCellProps) => {
  if (!row) return null;

  return (
    <DataCell name="Name">
      <NameCellWrap>
        <div>
          {row.admitDecision && row.admitDecision !== "Participant" ? (
            <BasicTitle $green>{row.admitDecision}</BasicTitle>
          ) : null}
          <TooltipWrap row={row} canShowTooltip={canShowTooltip}>
            <TableName as={InlineLink} href={PARTICIPANT_PATHS.detail(row.id)} forceNewTab={forceNewTab}>
              {row.firstName} {row.lastName}
            </TableName>
          </TooltipWrap>
        </div>

        {showExtraLinks && row.profile?.linkedin ? (
          <div>
            <TableName.Secondary as={InlineLink} href={row.profile.linkedin}>
              LinkedIn
            </TableName.Secondary>
          </div>
        ) : null}

        {showExtraLinks && row.profile?.finalResume ? (
          <div>
            <TableName.Secondary as={InlineLink} href={row.profile?.finalResume}>
              Resume
            </TableName.Secondary>
          </div>
        ) : null}
      </NameCellWrap>
    </DataCell>
  );
};

export default NameCell;
